import React, { Component } from "react";
import { MenuItem, Select, TextField } from "@mui/material";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";
import { states } from "../../../reducers/queriesStates";
import styles from "./cmsDeviceDataTools.module.scss";
import { withAuth } from "../../../shared/containers/containerAuth";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import Preloader from "../../../shared/items/static/preloader";
import { withDevices } from "../../../shared/containers/containerDevices";

class CmsDeviceDataTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      device: null,
      isError: false,
    };
  }

  componentDidMount() {
    const { currentDeviceDataState, currentDevice } = this.props;

    if (currentDeviceDataState === states.READY) {
      this.setState({ device: currentDevice });
    }

    const { dataStateProtocolMarkers, onGetProtocolMarkers } = this.props;

    if (dataStateProtocolMarkers === states.READY || dataStateProtocolMarkers === states.FAILURE) {
      onGetProtocolMarkers();
    }
  }

  componentDidUpdate(prevPeops) {
    const { currentDeviceDataState, currentDeviceUpdateDataState, currentDevice, dataStateProtocolMarkers, onErrorHandle } = this.props;

    if (currentDeviceDataState === states.READY && prevPeops.currentDeviceDataState === states.REQUEST) {
      this.setState({ device: currentDevice });
    }

    if (dataStateProtocolMarkers === states.FAILURE && prevPeops.dataStateProtocolMarkers === states.REQUEST) {
      onErrorHandle("Ошибка при получение маркеров протокола устройств");
    }

    if (currentDeviceUpdateDataState === states.FAILURE && prevPeops.currentDeviceUpdateDataState === states.REQUEST) {
      this.setState({ isError: true });

      setTimeout(() => {
        this.setState({ isError: false });
      }, 3000);
    }
  }

  onChangeImei(e) {
    const { device } = this.state;
    device.imei = e.target.value;
    this.setState(device);
  }

  onChangePhone(e) {
    const { device } = this.state;
    device.phone = e.target.value;
    this.setState(device);
  }

  onChangeNumberSim(e) {
    const { device } = this.state;
    device.numberSim = e.target.value;
    this.setState(device);
  }

  onChangeModel(e) {
    const { device } = this.state;
    device.model = e.target.value;
    this.setState(device);
  }

  onChangeDeviceType(e) {
    const { device } = this.state;
    device.type = e.target.value;
    this.setState(device);
  }

  onChangeGuaranteeStartDate(e) {
    const { device } = this.state;
    device.guaranteeStartDate = e.target.value + "T00:00:00";
    this.setState(device);
  }

  onChangeGuaranteeMounths(e) {
    const { device } = this.state;
    device.guaranteeMounths = Number(e.target.value);
    this.setState(device);
  }

  onChangeRent(e) {
    const { device } = this.state;
    device.isRent = !device.isRent;
    this.setState(device);
  }

  onHandleButtonClick() {
    const { onUpdateDevice } = this.props;
    const { device } = this.state;

    const options = {
      imei: device.imei,
      phone: device.phone,
      numberSim: device.numberSim,
      type: device.type,
      model: device.model,
      guaranteeStartDate: device.guaranteeStartDate,
      guaranteeMounths: device.guaranteeMounths,
      isRent: device.isRent,
    };

    onUpdateDevice(device.id, options);
  }

  render() {
    const { device, isError } = this.state;
    const { currentDeviceUpdateDataState, protocolMarkers } = this.props;

    if (device === null) {
      return null;
    }

    const disabled = !this.props.data.permissions.includes(30004);

    const disableButton = () => {
      if (device.numberSim !== null && device.numberSim.length > 0) {
        return device.numberSim.length < 19 || device.numberSim.length > 20;
      }

      return disabled || device.imei === null || device.imei === undefined || device.imei === "";
    };

    return (
      <div className={styles.cmsDeviceDataToolsContainer}>
        {isError ? <div className={styles.errorMessageContainer}>Не удалось обновить данные</div> : null}
        <div className={styles.toolsContainer}>
          <div className={styles.inputContainer}>
            <TextField
              disabled={disabled}
              id="outlined-basic"
              label="IMEI"
              variant="outlined"
              size="small"
              value={device.imei === null ? "" : device.imei}
              onChange={this.onChangeImei.bind(this)}
            />
          </div>

          <div className={styles.inputContainer}>
            <TextField
              disabled={disabled}
              id="outlined-basic"
              label="Телефон SIM"
              variant="outlined"
              size="small"
              value={device.phone === null ? "" : device.phone}
              onChange={this.onChangePhone.bind(this)}
            />
          </div>

          <div className={styles.inputContainer}>
            <TextField
              disabled={disabled}
              id="outlined-basic"
              label="Серийный номер SIM (ICCID)"
              variant="outlined"
              size="small"
              value={device.numberSim === null ? "" : device.numberSim}
              onChange={this.onChangeNumberSim.bind(this)}
            />
          </div>

          <div className={styles.inputContainer}>
            <Select
              style={{ minWidth: "200px", height: "33px" }}
              onChange={this.onChangeDeviceType.bind(this)}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={device.type}
            >
              {protocolMarkers !== null
                ? protocolMarkers.protocolMarkers.map((x, index) => {
                    return (
                      <MenuItem key={index} value={x.value} className={styles.MuiButtonBase_resolve}>
                        {x.title}
                      </MenuItem>
                    );
                  })
                : null}
            </Select>
          </div>

          <div className={styles.inputContainer}>
            <TextField
              disabled={disabled}
              id="outlined-basic"
              label="Модель устройства"
              variant="outlined"
              size="small"
              value={device.model === null ? "" : device.model}
              onChange={this.onChangeModel.bind(this)}
            />
          </div>

          <div className={styles.inputContainer}>
            <TextField
              disabled={disabled}
              id="outlined-basic"
              label="Начало гарантии"
              variant="outlined"
              size="small"
              type="date"
              value={device.guaranteeStartDate.replace("T00:00:00", "")}
              onChange={this.onChangeGuaranteeStartDate.bind(this)}
            />
          </div>

          <div className={styles.inputContainer}>
            <TextField
              disabled={disabled}
              id="outlined-basic"
              label="Срок (мес)"
              variant="outlined"
              size="small"
              type="number"
              value={device.guaranteeMounths}
              onChange={this.onChangeGuaranteeMounths.bind(this)}
            />
          </div>

          <div className={styles.inputContainerCheckbox} onClick={this.onChangeRent.bind(this)}>
            <input type="checkbox" key={device.id + "" + device.isRent} checked={device.isRent} />
            <span>В аренде</span>
          </div>

          <div>
            {currentDeviceUpdateDataState === states.REQUEST ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader />
              </div>
            ) : (
              <ButtonPrimary handleClick={this.onHandleButtonClick.bind(this)} title="Обновить" disabled={disableButton()} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(withCurrentDevices(withDevices(CmsDeviceDataTools)));
